// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"455":"6d563e1c","488":"9201d677","946":"2507fe7b"}[chunkId] + ".chunk.js";
};